(function () {
  var LOG_KEY = "optiplex_amblyopia_session_logs_v1";
  var PRESCRIPTION_KEY = "amblyopiaPrescription";
  var OLD_PRESCRIPTION_KEY = "optiplex_amblyopia_demo_prescription_v1";
  var VISIBILITY_KEY = "optiplex_amblyopia_game_visibility_v1";
  var AUDIO_KEY = "optiplex_amblyopia_audio_v1";
  var STARS_KEY = "optiplex_amblyopia_stars_v1";
  var RATINGS_KEY = "optiplex_amblyopia_ratings_v1";
  var CATEGORY_ACCESS_KEY = "optiplex_amblyopia_category_access_v1";
  var UNLOCKS_KEY = "optiplex_amblyopia_unlocks_v1";
  var CHARACTER_KEY = "optiplex_amblyopia_character_v1";
  var DEFAULT_STOP_SYMPTOMS = ["headache", "nausea", "dizziness", "distress", "persistent double vision"];

  var RED_GREEN_CHANNELS = {
    "red-green-dichoptic-catch": {
      gameKey: "red-green-dichoptic-catch",
      sharedElements: ["fixation", "score", "safe boundary"],
      amblyopicEyeElements: ["ball", "target objects"],
      fellowEyeElements: ["background structure"],
      suppressionCheckElements: ["redOnlyTarget", "greenOnlyTarget"]
    },
    "red-green-balance-dots": {
      gameKey: "red-green-balance-dots",
      sharedElements: ["fixation", "score", "safe boundary"],
      amblyopicEyeElements: ["target dots"],
      fellowEyeElements: ["comparison dots", "background structure"],
      suppressionCheckElements: ["redOnlyTarget", "greenOnlyTarget"]
    },
    "optiplex-fruit-slice": {
      gameKey: "optiplex-fruit-slice",
      sharedElements: ["fixation", "score", "safe boundary"],
      amblyopicEyeElements: ["target fruit"],
      fellowEyeElements: ["distractor fruit", "background structure"],
      suppressionCheckElements: ["redOnlyTarget", "greenOnlyTarget"]
    },
    "rocket-rescue": {
      gameKey: "rocket-rescue",
      sharedElements: ["fixation", "score", "safe boundary"],
      amblyopicEyeElements: ["rocket", "target objects"],
      fellowEyeElements: ["background structure"],
      suppressionCheckElements: ["redOnlyTarget", "greenOnlyTarget"]
    },
    "red-green-brick-breaker": {
      gameKey: "red-green-brick-breaker",
      sharedElements: ["fixation", "score", "safe boundary"],
      amblyopicEyeElements: ["ball", "target bricks"],
      fellowEyeElements: ["paddle", "brick outlines", "background structure"],
      suppressionCheckElements: ["redOnlyTarget", "greenOnlyTarget"]
    },
    redGreenBrickBreaker: {
      gameKey: "redGreenBrickBreaker",
      sharedElements: ["fixation", "score", "safe boundary"],
      amblyopicEyeElements: ["ball", "target bricks"],
      fellowEyeElements: ["paddle", "brick outlines", "background structure"],
      suppressionCheckElements: ["redOnlyTarget", "greenOnlyTarget"]
    },
    "red-green-paddle-rally": {
      gameKey: "red-green-paddle-rally",
      sharedElements: ["fixation", "score", "safe boundary"],
      amblyopicEyeElements: ["ball", "target objects"],
      fellowEyeElements: ["paddle", "obstacles", "background structure"],
      suppressionCheckElements: ["redOnlyTarget", "greenOnlyTarget"]
    },
    redGreenPaddleRally: {
      gameKey: "redGreenPaddleRally",
      sharedElements: ["fixation", "score", "safe boundary"],
      amblyopicEyeElements: ["ball", "target objects"],
      fellowEyeElements: ["paddle", "obstacles", "background structure"],
      suppressionCheckElements: ["redOnlyTarget", "greenOnlyTarget"]
    },
    "fusion-garden": {
      gameKey: "fusion-garden",
      sharedElements: ["fixation", "score", "safe boundary"],
      amblyopicEyeElements: ["amblyopic-eye flowers"],
      fellowEyeElements: ["fellow-eye flowers", "background structure"],
      suppressionCheckElements: ["redOnlyTarget", "greenOnlyTarget"]
    }
  };

  function createSessionId() {
    return "amb-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 10);
  }

  function getNowIso() {
    return new Date().toISOString();
  }

  // ==========================================================================================
  // BATCH 55 — STORAGE INTEGRITY (Tier 2 exception, recorded in CORE-CONTROL-b55.json).
  // readJson previously could not tell "fresh install" from "corrupt data": both returned the
  // fallback, and every caller then wrote that fallback back over the original bytes (audit-
  // proven destruction of PROGRESS/PRESCRIPTION/PROFILE/LOG data). Three failure classes now:
  //   1. getItem THROWS (private mode / storage disabled) — storage UNAVAILABLE, not
  //      corruption. Fallback as before; nothing poisoned.
  //   2. getItem returns null/"" — genuinely ABSENT, a fresh install. Fallback; not poisoned.
  //   3. getItem returns a non-empty string and JSON.parse THROWS — CORRUPTION. The raw bytes
  //      are quarantined (best-effort copy under <key>__corrupt_<ISO>), the key is POISONED,
  //      and the fallback is returned so the app keeps running.
  // writeJson then REFUSES to write a poisoned key — that single rule keeps the corrupt-but-
  // recoverable original on disk. The poison set is in-memory ONLY, deliberately: while the
  // corrupt bytes remain, the next boot's first read (or first write's validation) re-poisons
  // the key, so protection re-arms itself across restarts; it clears only through the explicit
  // clinician recovery action (recoverPoisonedKey) — never automatically, never on boot.
  // THERAPY IS NEVER BLOCKED: a poisoned key only stops writes to that key; reads serve the
  // fallback and sessions start, run and end normally. Nothing here reads or writes the
  // therapy timer or any dose gate (G3).
  var poisonedKeys = {};        // key -> ISO time first poisoned this page load
  var writeValidatedKeys = {};  // keys whose stored value was checked before this load's first write
  var lastWriteFailures = {};   // key -> { at, reason: "poisoned" | "quota-or-unavailable" }
  var QUARANTINE_MARKER = "__corrupt_";

  function quarantineCorruptValue(key, raw) {
    // Best-effort and throw-proof; bypasses writeJson (the poison gate must not stop it).
    // Skips the copy when an identical quarantine already exists, so a corrupt key that
    // re-poisons on every boot does not accumulate duplicates.
    try {
      for (var i = 0; i < window.localStorage.length; i += 1) {
        var existing = window.localStorage.key(i);
        if (existing && existing.indexOf(key + QUARANTINE_MARKER) === 0 &&
            window.localStorage.getItem(existing) === raw) return;
      }
      window.localStorage.setItem(key + QUARANTINE_MARKER + getNowIso(), raw);
    } catch (error) {}
  }

  function poisonKey(key, raw) {
    if (!poisonedKeys[key]) {
      poisonedKeys[key] = getNowIso();
      quarantineCorruptValue(key, raw);
    }
  }

  function readJson(key, fallback) {
    var raw;
    try {
      raw = window.localStorage.getItem(key);
    } catch (error) {
      return fallback;                       // class 1: storage unavailable — not corruption
    }
    if (raw === null || raw === "") {
      return fallback;                       // class 2: genuinely absent — fresh install
    }
    try {
      return JSON.parse(raw);
    } catch (error) {
      poisonKey(key, raw);                   // class 3: corruption — quarantine, poison, run on
      return fallback;
    }
  }

  function writeJson(key, value) {
    // BATCH 55: refuse to overwrite a poisoned key — the corrupt original stays recoverable.
    if (poisonedKeys[key]) {
      lastWriteFailures[key] = { at: getNowIso(), reason: "poisoned" };
      return false;
    }
    // First write to this key this load: verify the stored value is not corrupt before
    // overwriting it. Closes the write-without-a-prior-read hole; one check per key per load.
    if (!writeValidatedKeys[key] && key.indexOf(QUARANTINE_MARKER) === -1) {
      try {
        var existing = window.localStorage.getItem(key);
        if (existing !== null && existing !== "") {
          try {
            JSON.parse(existing);
          } catch (parseError) {
            poisonKey(key, existing);
            lastWriteFailures[key] = { at: getNowIso(), reason: "poisoned" };
            return false;
          }
        }
      } catch (error) {}                     // storage unavailable: fall through to the attempt
      writeValidatedKeys[key] = true;
    }
    // Guarded so a transient storage failure (private mode, quota) can never throw mid-save
    // and abort the caller. localStorage is durable: what is written here survives full app
    // close, browser close and device restart, and is only removed by clearAllStoredData.
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (error) {
      // BATCH 55: recorded instead of swallowed — surfaced read-only via getStorageHealth().
      lastWriteFailures[key] = { at: getNowIso(), reason: "quota-or-unavailable" };
      return false;
    }
  }

  // Read-only diagnostics for the clinician surface (BATCH 55). Mutates nothing.
  function getStorageHealth() {
    var quarantine = [];
    try {
      for (var i = 0; i < window.localStorage.length; i += 1) {
        var k = window.localStorage.key(i);
        var idx = k ? k.indexOf(QUARANTINE_MARKER) : -1;
        if (idx > 0) {
          var bytes = 0;
          try { bytes = (window.localStorage.getItem(k) || "").length; } catch (eQ) {}
          quarantine.push({ key: k.slice(0, idx), quarantineKey: k, at: k.slice(idx + QUARANTINE_MARKER.length), bytes: bytes });
        }
      }
    } catch (error) {}
    var poisoned = [];
    Object.keys(poisonedKeys).forEach(function (k) { poisoned.push({ key: k, at: poisonedKeys[k] }); });
    var failures = {};
    Object.keys(lastWriteFailures).forEach(function (k) { failures[k] = { at: lastWriteFailures[k].at, reason: lastWriteFailures[k].reason }; });
    return { poisonedKeys: poisoned, lastWriteFailures: failures, quarantine: quarantine };
  }

  // Raw quarantined bytes for the clinician export — unparseable by definition, so raw string.
  function readQuarantinedRaw(quarantineKey) {
    try { return window.localStorage.getItem(quarantineKey) || ""; } catch (error) { return ""; }
  }

  // G4 EXPLICIT RECOVERY ONLY — called from the clinician's confirmed "discard" action, never
  // automatically and never on boot. Discards the corrupt stored value AND its quarantine
  // copies, un-poisons the key, and lets normal writes resume.
  function recoverPoisonedKey(key) {
    try { window.localStorage.removeItem(key); } catch (error) {}
    try {
      var doomed = [];
      for (var i = 0; i < window.localStorage.length; i += 1) {
        var k = window.localStorage.key(i);
        if (k && k.indexOf(key + QUARANTINE_MARKER) === 0) doomed.push(k);
      }
      doomed.forEach(function (k) { try { window.localStorage.removeItem(k); } catch (e2) {} });
    } catch (error) {}
    delete poisonedKeys[key];
    delete lastWriteFailures[key];
    delete writeValidatedKeys[key];
    return true;
  }

  // Ask the browser to keep this origin's storage indefinitely instead of evicting it under
  // storage pressure or inactivity heuristics (e.g. iOS/iPadOS). This is what lets the saved
  // profile/progress survive a device power-off for good. Best-effort and non-blocking.
  function requestPersistentStorage() {
    try {
      if (navigator.storage && typeof navigator.storage.persist === "function") {
        var result = navigator.storage.persist();
        if (result && typeof result.catch === "function") result.catch(function () {});
        return result;
      }
    } catch (error) {}
    return null;
  }

  // The complete set of persisted keys. Used ONLY by the clinician "reset game data" action
  // (via clearAllStoredData) - nothing else clears these, so normal use/close/restart keeps
  // everything.
  function allStorageKeys() {
    return [LOG_KEY, PRESCRIPTION_KEY, OLD_PRESCRIPTION_KEY, VISIBILITY_KEY, AUDIO_KEY, STARS_KEY, RATINGS_KEY, CATEGORY_ACCESS_KEY, UNLOCKS_KEY, CHARACTER_KEY];
  }

  function clearAllStoredData() {
    allStorageKeys().forEach(function (key) {
      try { window.localStorage.removeItem(key); } catch (error) {}
    });
  }

  function saveSessionLog(log) {
    var logs = getSessionLogs();
    logs.unshift(log);
    writeJson(LOG_KEY, logs.slice(0, 150));
    return logs[0];
  }

  function getSessionLogs() {
    var logs = readJson(LOG_KEY, []);
    return Array.isArray(logs) ? logs : [];
  }

  function clearSessionLogs() {
    window.localStorage.removeItem(LOG_KEY);
  }

  function getStarsMap() {
    var map = readJson(STARS_KEY, {});
    return map && typeof map === "object" && !Array.isArray(map) ? map : {};
  }

  function starsKey(gameKey, level) {
    return String(gameKey || "") + ":" + String(Math.max(1, parseInt(level, 10) || 1));
  }

  function getStars(gameKey, level) {
    var stars = parseInt(getStarsMap()[starsKey(gameKey, level)] || 0, 10);
    return Number.isFinite(stars) ? clamp(stars, 0, 3) : 0;
  }

  function saveStars(gameKey, level, stars) {
    var map = getStarsMap();
    var key = starsKey(gameKey, level);
    var next = clamp(parseInt(stars, 10) || 0, 0, 3);
    map[key] = Math.max(parseInt(map[key] || 0, 10) || 0, next);
    writeJson(STARS_KEY, map);
    return map[key];
  }

  function getTotalStars() {
    var map = getStarsMap();
    return Object.keys(map).reduce(function (total, key) {
      var stars = parseInt(map[key] || 0, 10);
      return total + (Number.isFinite(stars) ? clamp(stars, 0, 3) : 0);
    }, 0);
  }

  function getRatings() {
    var ratings = readJson(RATINGS_KEY, {});
    return ratings && typeof ratings === "object" && !Array.isArray(ratings) ? ratings : {};
  }

  function saveRating(gameKey, rating) {
    var ratings = getRatings();
    var value = clamp(parseInt(rating, 10) || 0, 0, 5);
    if (gameKey && value) {
      ratings[gameKey] = {
        rating: value,
        updatedAt: getNowIso()
      };
      writeJson(RATINGS_KEY, ratings);
    }
    return ratings;
  }

  function oppositeEye(eye) {
    return String(eye || "").toLowerCase() === "right" ? "left" : "right";
  }

  function normalizeAcuityValue(value) {
    var raw = String(value || "").trim().replace(/\s+/g, "");
    var match = raw.match(/^6\/(6|7\.5|9|12|18|24|30|36|60)$/);
    return match ? "6/" + match[1] : "";
  }

  function acuityDecimal(value) {
    var normalized = normalizeAcuityValue(value);
    if (!normalized) return null;
    var denominator = parseFloat(normalized.split("/")[1]);
    return denominator ? 6 / denominator : null;
  }

  var ACUITY_LADDER = ["6/6", "6/7.5", "6/9", "6/12", "6/18", "6/24", "6/30", "6/36", "6/60"];

  function getAcuityLineIndex(value) {
    var idx = ACUITY_LADDER.indexOf(normalizeAcuityValue(value));
    return idx === -1 ? null : idx;
  }

  // Converts a clinician-tunable "fellow eye contrast %" target (see
  // VA_DISPLAY_BALANCE_CONFIG in amblyopia-config.js) into the displayBalance value
  // that getFellowChannelAlpha's existing taper needs to hit that target - so the
  // config table stays in clinically meaningful units even if the taper is retuned.
  function displayBalanceForFellowContrastPercent(percent) {
    var target = clamp(Number(percent), 0, 100) / 100;
    var t = clamp((1 - target) / (1 - FELLOW_CONTRAST_FLOOR), 0, 1);
    return Math.round(FELLOW_CONTRAST_BALANCE_FLOOR + t * (FELLOW_CONTRAST_BALANCE_CEILING - FELLOW_CONTRAST_BALANCE_FLOOR));
  }

  function calculateAutoDisplayBalance(profile) {
    var p = profile || {};
    var amblyopicEye = p.amblyopicEye === "right" ? "right" : p.amblyopicEye === "left" ? "left" : "";
    var acuity = p.acuity || {};
    var va = amblyopicEye === "right" ? acuity.right : amblyopicEye === "left" ? acuity.left : "";
    var config = (window.OptiplexAmblyopiaConfig || {}).VA_DISPLAY_BALANCE_CONFIG || {};
    var vaIndex = getAcuityLineIndex(va);
    if (vaIndex == null) {
      var fallback = config.defaultFellowContrastPercent == null ? 100 : config.defaultFellowContrastPercent;
      return displayBalanceForFellowContrastPercent(fallback);
    }
    var bands = config.bands || [];
    for (var i = 0; i < bands.length; i += 1) {
      var band = bands[i];
      var boundA = getAcuityLineIndex(band.minVA);
      var boundB = getAcuityLineIndex(band.maxVA);
      if (boundA == null || boundB == null) continue;
      var lo = Math.min(boundA, boundB);
      var hi = Math.max(boundA, boundB);
      if (vaIndex >= lo && vaIndex <= hi) return displayBalanceForFellowContrastPercent(band.fellowContrastPercent);
    }
    return displayBalanceForFellowContrastPercent(config.defaultFellowContrastPercent == null ? 100 : config.defaultFellowContrastPercent);
  }

  function normalizeAcuityInput(old) {
    var acuity = (old || {}).acuity || {};
    return {
      right: normalizeAcuityValue(acuity.right || old.rightAcuity || old.acuityRight),
      left: normalizeAcuityValue(acuity.left || old.leftAcuity || old.acuityLeft),
      source: acuity.source || "parent-entered",
      baselineSetAt: acuity.baselineSetAt || old.acuityBaselineSetAt || ""
    };
  }

  function inferEyesFromAcuity(acuity, fallbackStrongerEye, fallbackAmblyopicEye) {
    var rightDecimal = acuityDecimal(acuity && acuity.right);
    var leftDecimal = acuityDecimal(acuity && acuity.left);
    if (rightDecimal != null && leftDecimal != null && Math.abs(rightDecimal - leftDecimal) > 0.0001) {
      return rightDecimal < leftDecimal ? { strongerEye: "left", amblyopicEye: "right", patchEye: "left" } : { strongerEye: "right", amblyopicEye: "left", patchEye: "right" };
    }
    var strongerEye = fallbackStrongerEye || "";
    if (strongerEye !== "left" && strongerEye !== "right" && (fallbackAmblyopicEye === "left" || fallbackAmblyopicEye === "right")) strongerEye = oppositeEye(fallbackAmblyopicEye);
    return inferEyes(strongerEye);
  }

  function inferEyes(strongerEye) {
    if (strongerEye !== "left" && strongerEye !== "right") {
      return { strongerEye: "", amblyopicEye: "", patchEye: "" };
    }
    return {
      strongerEye: strongerEye,
      amblyopicEye: oppositeEye(strongerEye),
      patchEye: strongerEye
    };
  }

  function childAgeNumber(years, months) {
    var y = parseInt(years, 10);
    var m = parseInt(months || 0, 10);
    if (!Number.isFinite(y)) return "";
    if (!Number.isFinite(m)) m = 0;
    return Number((y + clamp(m, 0, 11) / 12).toFixed(2));
  }

  function ageParts(age) {
    var numeric = Number(age);
    if (!Number.isFinite(numeric) || numeric <= 0) return { years: "", months: 0 };
    var years = Math.floor(numeric);
    var months = Math.round((numeric - years) * 12);
    if (months >= 12) {
      years += 1;
      months = 0;
    }
    return { years: years, months: months };
  }

  function getAgeBand(ageYears) {
    var age = Number(ageYears);
    if (!Number.isFinite(age) || age < 3) return "";
    if (age <= 5) return "preschool";
    if (age <= 8) return "early-primary";
    if (age <= 11) return "primary";
    return "older-child";
  }

  function createRedGreenProfile(profile) {
    var channels = getRedGreenChannels({ amblyopicEye: profile.amblyopicEye });
    return {
      amblyopicEyeChannel: channels.amblyopicEyeChannel,
      fellowEyeChannel: channels.fellowEyeChannel,
      displayBalance: calculateAutoDisplayBalance(profile)
    };
  }

  function normalizeTherapyProfile(input, defaults) {
    var base = defaults || {};
    var old = input || {};
    var strongerEye = old.strongerEye || "";
    if (!strongerEye && old.prescribedEye) strongerEye = old.prescribedEye;
    if (strongerEye !== "left" && strongerEye !== "right") strongerEye = "";
    var acuity = normalizeAcuityInput(old);
    var eyes = inferEyesFromAcuity(acuity, strongerEye, old.amblyopicEye);
    var existingAge = typeof old.childAge === "number" ? ageParts(old.childAge) : old.childAge || {};
    var years = parseInt(existingAge.years || old.childAgeYears || "", 10);
    var months = parseInt(existingAge.months || old.childAgeMonths || "0", 10);
    if (!Number.isFinite(years)) years = "";
    if (!Number.isFinite(months)) months = 0;
    var patchDurationSeconds = parseInt(old.patchDurationSeconds || old.patchSeconds || base.patchDurationSeconds || 1200, 10);
    var redGreenDurationSeconds = parseInt(old.redGreenDurationSeconds || old.redGreenSeconds || base.redGreenDurationSeconds || 600, 10);
    var profile = {
      strongerEye: eyes.strongerEye,
      amblyopicEye: eyes.amblyopicEye || old.amblyopicEye || "",
      patchEye: eyes.patchEye || old.patchEye || "",
      acuity: acuity,
      childAge: childAgeNumber(years, months),
      childAgeYears: years,
      childAgeMonths: clamp(months, 0, 11),
      ageBand: old.ageBand || getAgeBand(years),
      patchDurationSeconds: Math.max(60, patchDurationSeconds || 1200),
      redGreenDurationSeconds: Math.max(60, redGreenDurationSeconds || 600),
      difficulty: old.difficulty || base.difficulty || "easy",
      safety: {
        restPromptMinutes: parseInt((old.safety || {}).restPromptMinutes || 20, 10) || 20,
        stopSymptoms: (old.safety || {}).stopSymptoms || DEFAULT_STOP_SYMPTOMS.slice()
      }
    };
    profile.redGreen = createRedGreenProfile(profile);
    return profile;
  }

  function normalizePrescription(input, defaults) {
    return normalizeTherapyProfile(input, defaults);
  }

  function getStoredPrescription(defaults) {
    var current = readJson(PRESCRIPTION_KEY, null);
    var legacy = readJson(OLD_PRESCRIPTION_KEY, null);
    return normalizeTherapyProfile(current || legacy || null, defaults);
  }

  function getStoredTherapyProfile(defaults) {
    return getStoredPrescription(defaults);
  }

  function saveTherapyProfile(profile) {
    var normalized = normalizeTherapyProfile(profile, profile);
    writeJson(PRESCRIPTION_KEY, normalized);
    return normalized;
  }

  function createTimer(seconds, onTick, onComplete) {
    var duration = Math.max(1, parseInt(seconds, 10) || 1);
    var startedAt = 0;
    // BATCH 54 (Tier 2 exception, CORE-CONTROL-b54.json): banked in MILLISECONDS. The previous
    // integer bank floored at every pause()/stop(), discarding 0-0.999s per call; the fraction
    // now survives and is floored ONLY at read, so the external integer-seconds API is unchanged.
    var elapsedBeforePauseMs = 0;
    var interval = null;
    var running = false;
    function elapsedMs() {
      if (!running) return elapsedBeforePauseMs;
      return elapsedBeforePauseMs + (Date.now() - startedAt);
    }
    function elapsed() {
      return Math.min(duration, Math.floor(elapsedMs() / 1000));
    }
    function tick() {
      var current = elapsed();
      if (onTick) onTick(current, Math.max(0, duration - current));
      if (current >= duration) {
        api.stop();
        if (onComplete) onComplete(current);
      }
    }
    var api = {
      start: function () {
        if (running) return;
        running = true;
        startedAt = Date.now();
        tick();
        interval = window.setInterval(tick, 250);
      },
      pause: function () {
        if (!running) return;
        elapsedBeforePauseMs = elapsedMs();
        running = false;
        window.clearInterval(interval);
        interval = null;
      },
      stop: function () {
        elapsedBeforePauseMs = elapsedMs();
        running = false;
        window.clearInterval(interval);
        interval = null;
      },
      reset: function () {
        window.clearInterval(interval);
        startedAt = 0;
        elapsedBeforePauseMs = 0;
        interval = null;
        running = false;
      },
      getElapsed: elapsed,
      getRemaining: function () {
        return Math.max(0, duration - elapsed());
      },
      isRunning: function () {
        return running;
      },
      duration: duration
    };
    return api;
  }

  function formatSeconds(seconds) {
    var value = Math.max(0, Math.floor(Number(seconds) || 0));
    var minutes = Math.floor(value / 60);
    var remainder = value % 60;
    return String(minutes).padStart(2, "0") + ":" + String(remainder).padStart(2, "0");
  }

  function randomBetween(min, max) {
    return min + Math.random() * (max - min);
  }

  function randomChoice(items) {
    return items[Math.floor(Math.random() * items.length)];
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function getDifficultySettings(difficulty, overrides) {
    var map = {
      easy: {
        targetSize: 74,
        targetSpeed: 0.75,
        contrast: 1,
        crowding: 0,
        distractors: 4,
        ballSpeed: 4.1,
        paddleSize: 150,
        computerSkill: 0.42,
        brickRows: 3,
        brickSize: 1,
        durationScale: 1
      },
      medium: {
        targetSize: 58,
        targetSpeed: 1,
        contrast: 0.86,
        crowding: 1,
        distractors: 8,
        ballSpeed: 5.2,
        paddleSize: 126,
        computerSkill: 0.58,
        brickRows: 4,
        brickSize: 0.9,
        durationScale: 1
      },
      hard: {
        targetSize: 44,
        targetSpeed: 1.32,
        contrast: 0.72,
        crowding: 2,
        distractors: 12,
        ballSpeed: 6.3,
        paddleSize: 104,
        computerSkill: 0.74,
        brickRows: 5,
        brickSize: 0.82,
        durationScale: 1
      }
    };
    var selected = map[difficulty] || map.easy;
    var result = {};
    Object.keys(selected).forEach(function (key) {
      result[key] = selected[key];
    });
    if (overrides) {
      Object.keys(overrides).forEach(function (key) {
        result[key] = overrides[key];
      });
    }
    return result;
  }

  function createTarget(bounds, settings) {
    var size = settings && settings.targetSize ? settings.targetSize : 58;
    var width = bounds.width || 900;
    var height = bounds.height || 560;
    return {
      x: randomBetween(size, width - size),
      y: randomBetween(size, height - size),
      radius: size / 2,
      glyph: randomChoice(["A", "H", "K", "M", "S", "T", "2", "5", "7", "9"]),
      age: 0,
      life: randomBetween(1600, 2600)
    };
  }

  function createMovingTarget(bounds, settings) {
    var target = createTarget(bounds, settings);
    var speed = settings && settings.targetSpeed ? settings.targetSpeed : 1;
    target.vx = randomBetween(-1.8, 1.8) * speed;
    target.vy = randomBetween(-1.5, 1.5) * speed;
    return target;
  }

  function createRedGreenCalibration() {
    // The amblyopic-eye target is always red, the fellow eye always green (see
    // getRedGreenChannels) - never swapped by which eye is amblyopic.
    return {
      amblyopicEyeChannel: "red",
      fellowEyeChannel: "green",
      displayBalance: 50
    };
  }

  // Legacy helper describing the physical lens colour historically assumed per eye. It is NO
  // LONGER used to colour any target - the amblyopic target is always red and the fellow
  // content always green (see getRedGreenChannels), so this never influences rendering. Kept
  // only for API compatibility.
  function mapAmblyopicEyeToColour(eye) {
    return String(eye).toLowerCase() === "right" ? "red" : "green";
  }

  function getRedGreenChannels(profile) {
    // CLINICAL RULE: the amblyopic (treatment) eye's target is ALWAYS red and the fellow-eye
    // content is ALWAYS green, for every child - regardless of which eye is amblyopic. The
    // physical red/green glasses are picked per child (red-over-left or red-over-right) so the
    // red lens always sits over the amblyopic eye; the app must NOT also swap the colour by eye.
    // profile.amblyopicEye still decides which ELEMENTS carry the amblyopic vs fellow role
    // (target = amblyopic, obstacles/background = fellow), but the COLOUR of each role is fixed
    // here and never depends on left/right. (profile is intentionally unused.)
    return {
      amblyopicEyeChannel: "red",
      fellowEyeChannel: "green"
    };
  }

  function syncRedGreenChannels(profile) {
    var channels = getRedGreenChannels(profile);
    if (!profile.redGreen) profile.redGreen = {};
    profile.redGreen.amblyopicEyeChannel = channels.amblyopicEyeChannel;
    profile.redGreen.fellowEyeChannel = channels.fellowEyeChannel;
    return profile.redGreen;
  }

  function channelHex(channel) {
    // Fixed clinic convention (see mapAmblyopicEyeToColour): red lens = right eye,
    // green/cyan lens = left eye, always - these hex values are the clinician-calibrated
    // colours for each physical channel (tested against the real glasses), stored in
    // amblyopia-config.js so every red/cyan game reads the same values. They are not
    // tied to which eye is amblyopic; that mapping is resolved by getRedGreenChannels.
    var colours = (window.OptiplexAmblyopiaConfig || {}).DICHOPTIC_COLOR_CONFIG || {};
    return channel === "green" ? (colours.greenChannelHex || "#00a86b") : channel === "red" ? (colours.redChannelHex || "#df2434") : "#ffffff";
  }

  // Fellow-eye contrast tapers with displayBalance: 1 (no weakening) at the low end of
  // the displayBalance scale, down to a deliberately weak floor at the high end. The
  // amblyopic eye is never touched by this - it always gets the full, high-contrast
  // signal, so it can never end up weaker than the fellow eye. displayBalance itself is
  // set purely from the clinician's measured VA (see calculateAutoDisplayBalance) - never
  // from in-game score, time played, or level reached.
  var FELLOW_CONTRAST_CEILING = 1;
  var FELLOW_CONTRAST_FLOOR = 0.15;
  var FELLOW_CONTRAST_BALANCE_FLOOR = 50;
  var FELLOW_CONTRAST_BALANCE_CEILING = 85;

  function getFellowChannelAlpha(profile) {
    var raw = ((profile || {}).redGreen || {}).displayBalance;
    var parsed = parseInt(raw == null ? 50 : raw, 10);
    var balance = Number.isFinite(parsed) ? clamp(parsed, 0, 100) : 50;
    var span = Math.max(1, FELLOW_CONTRAST_BALANCE_CEILING - FELLOW_CONTRAST_BALANCE_FLOOR);
    var t = clamp((balance - FELLOW_CONTRAST_BALANCE_FLOOR) / span, 0, 1);
    return FELLOW_CONTRAST_CEILING - t * (FELLOW_CONTRAST_CEILING - FELLOW_CONTRAST_FLOOR);
  }

  function getChannelAlpha(profile, role) {
    if (role === "shared") return 1;
    if (role === "amblyopic") return 1;
    if (role === "fellow") return getFellowChannelAlpha(profile);
    return 1;
  }

  function getStimulusColour(profile, role) {
    if (role === "shared") return "#ffffff";
    var channels = getRedGreenChannels(profile);
    return channelHex(role === "fellow" ? channels.fellowEyeChannel : channels.amblyopicEyeChannel);
  }

  function renderStimulusElement(context, profile, role, draw) {
    context.save();
    context.globalAlpha *= getChannelAlpha(profile, role);
    context.fillStyle = getStimulusColour(profile, role);
    context.strokeStyle = getStimulusColour(profile, role);
    draw(context, getStimulusColour(profile, role));
    context.restore();
  }

  function applyStimulusElement(element, profile, role) {
    if (!element || !element.style) return element;
    element.style.background = getStimulusColour(profile, role);
    element.style.color = role === "shared" ? "#163158" : "#ffffff";
    element.style.setProperty("--amb-channel-opacity", String(getChannelAlpha(profile, role)));
    return element;
  }

  function getStimulusChannels(gameKey) {
    return RED_GREEN_CHANNELS[gameKey] || {
      gameKey: gameKey,
      sharedElements: ["fixation", "score", "safe boundary"],
      amblyopicEyeElements: ["target objects"],
      fellowEyeElements: ["background structure"],
      suppressionCheckElements: ["redOnlyTarget", "greenOnlyTarget"]
    };
  }

  function createStimulusConfig(profile, game, level, options, audio) {
    var opts = options || {};
    var settings = getDifficultySettings((profile || {}).difficulty || "easy");
    var activeLevel = Math.max(1, parseInt(level, 10) || 1);
    var bonus = activeLevel - 1;
    return {
      moduleType: game && game.module === "redgreen" ? "redGreen" : "patch",
      level: activeLevel,
      targetSize: Math.max(28, settings.targetSize - bonus * 4),
      targetSpeed: settings.targetSpeed + bonus * 0.12,
      spawnRate: Math.max(260, 900 - bonus * 65),
      crowding: settings.crowding + Math.floor(bonus / 2),
      contrast: settings.contrast,
      displayBalance: ((profile || {}).redGreen || {}).displayBalance == null ? 50 : ((profile || {}).redGreen || {}).displayBalance,
      canLose: !!opts.canLose,
      soundEnabled: !!((audio || {}).sound),
      musicEnabled: !!((audio || {}).music),
      paddleSize: Math.max(82, settings.paddleSize - (opts.challengeMode ? bonus * 5 : 0)),
      ballSpeed: settings.ballSpeed + bonus * 0.35,
      brickRows: Math.min(8, settings.brickRows + Math.floor(bonus / 2)),
      brickSize: settings.brickSize,
      distractors: settings.distractors + bonus * 2,
      computerSkill: settings.computerSkill + bonus * 0.02,
      channelConfig: game ? getStimulusChannels(game.key) : null
    };
  }

  function calculateSuppressionFlag(data) {
    if (!data) return false;
    var redMisses = Number(data.redMisses) || 0;
    var greenMisses = Number(data.greenMisses) || 0;
    var amblyopicColour = data.amblyopicColour || "red";
    if (amblyopicColour === "red" && redMisses >= 3 && redMisses > greenMisses + 1) return true;
    if (amblyopicColour === "green" && greenMisses >= 3 && greenMisses > redMisses + 1) return true;
    return false;
  }

  function fitCanvasToDisplay(canvas) {
    return resizeGameCanvas(canvas, canvas.parentElement);
  }

  function resizeGameCanvas(canvas, container) {
    var rect = (container || canvas).getBoundingClientRect();
    var viewport = window.visualViewport || {};
    var fallbackWidth = viewport.width || window.innerWidth || document.documentElement.clientWidth || 900;
    var fallbackHeight = viewport.height || window.innerHeight || document.documentElement.clientHeight || 560;
    var width = Math.max(1, Math.floor(Math.min(rect.width || fallbackWidth, fallbackWidth)));
    var height = Math.max(1, Math.floor(Math.min(rect.height || fallbackHeight, fallbackHeight)));
    var ratio = window.devicePixelRatio || 1;
    var internalWidth = Math.floor(width * ratio);
    var internalHeight = Math.floor(height * ratio);
    if (canvas.width !== internalWidth || canvas.height !== internalHeight) {
      canvas.width = internalWidth;
      canvas.height = internalHeight;
    }
    var context = canvas.getContext("2d");
    context.setTransform(ratio, 0, 0, ratio, 0, 0);
    return { width: width, height: height, ratio: ratio, context: context };
  }

  function getPointerPosition(event, canvas) {
    var rect = canvas.getBoundingClientRect();
    return {
      x: (event.clientX - rect.left) * (canvas.width / rect.width) / (window.devicePixelRatio || 1),
      y: (event.clientY - rect.top) * (canvas.height / rect.height) / (window.devicePixelRatio || 1)
    };
  }

  function clearCanvas(context, width, height, fill) {
    context.clearRect(0, 0, width, height);
    context.fillStyle = fill || "#102845";
    context.fillRect(0, 0, width, height);
  }

  function roundedRect(context, x, y, width, height, radius) {
    var r = Math.max(0, Math.min(radius, Math.abs(width) / 2, Math.abs(height) / 2));
    context.beginPath();
    context.moveTo(x + r, y);
    context.lineTo(x + width - r, y);
    context.quadraticCurveTo(x + width, y, x + width, y + r);
    context.lineTo(x + width, y + height - r);
    context.quadraticCurveTo(x + width, y + height, x + width - r, y + height);
    context.lineTo(x + r, y + height);
    context.quadraticCurveTo(x, y + height, x, y + height - r);
    context.lineTo(x, y + r);
    context.quadraticCurveTo(x, y, x + r, y);
    context.closePath();
  }

  function drawFixation(context, width, height) {
    context.save();
    context.strokeStyle = "rgba(255,255,255,0.82)";
    context.lineWidth = 3;
    context.beginPath();
    context.moveTo(width / 2 - 16, height / 2);
    context.lineTo(width / 2 + 16, height / 2);
    context.moveTo(width / 2, height / 2 - 16);
    context.lineTo(width / 2, height / 2 + 16);
    context.stroke();
    context.restore();
  }

  function createScore() {
    return {
      score: 0,
      hits: 0,
      correctTaps: 0,
      misses: 0,
      errors: 0,
      falseTaps: 0,
      wrongTaps: 0,
      wrongHits: 0,
      redMisses: 0,
      greenMisses: 0,
      bricksCleared: 0,
      ralliesCompleted: 0,
      longestRally: 0,
      level: 1,
      highestLevelReached: 1,
      levelAttempts: 1,
      levelFailed: false,
      powerUpsUsed: [],
      livesLost: 0,
      differencesFound: 0,
      timerExpired: false,
      continuedAfterTimeout: false,
      scorePenaltyApplied: 0,
      gamesWon: 0,
      gamesLost: 0,
      matchScore: "0-0",
      canLose: false,
      practiceMode: true,
      challengeMode: false,
      levelGoal: 0,
      levelProgress: 0,
      levelComplete: false,
      rewardHits: 0,
      rewardMisses: 0,
      rewardWrongTaps: 0,
      combo: 0,
      bestCombo: 0,
      learningTasks: [],
      skillArea: ""
    };
  }

  var activeKeyboardHandler = null;

  function activateGameKeyboardControls(handler) {
    deactivateGameKeyboardControls();
    activeKeyboardHandler = function (event) {
      var keys = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", " "];
      if (keys.indexOf(event.key) >= 0) event.preventDefault();
      if (handler) handler(event);
    };
    window.addEventListener("keydown", activeKeyboardHandler, { passive: false });
  }

  function deactivateGameKeyboardControls() {
    if (activeKeyboardHandler) window.removeEventListener("keydown", activeKeyboardHandler);
    activeKeyboardHandler = null;
  }

  window.OptiplexAmblyopiaCore = {
    keys: {
      logs: LOG_KEY,
      prescription: PRESCRIPTION_KEY,
      oldPrescription: OLD_PRESCRIPTION_KEY,
      visibility: VISIBILITY_KEY,
      audio: AUDIO_KEY,
      stars: STARS_KEY,
      ratings: RATINGS_KEY,
      categoryAccess: CATEGORY_ACCESS_KEY,
      unlocks: UNLOCKS_KEY,
      character: CHARACTER_KEY
    },
    oppositeEye: oppositeEye,
    inferEyes: inferEyes,
    normalizeAcuityValue: normalizeAcuityValue,
    acuityDecimal: acuityDecimal,
    inferEyesFromAcuity: inferEyesFromAcuity,
    getAgeBand: getAgeBand,
    ageParts: ageParts,
    childAgeNumber: childAgeNumber,
    normalizeTherapyProfile: normalizeTherapyProfile,
    getStoredTherapyProfile: getStoredTherapyProfile,
    saveTherapyProfile: saveTherapyProfile,
    normalizePrescription: normalizePrescription,
    getStoredPrescription: getStoredPrescription,
    createSessionId: createSessionId,
    getNowIso: getNowIso,
    saveSessionLog: saveSessionLog,
    getSessionLogs: getSessionLogs,
    clearSessionLogs: clearSessionLogs,
    getStarsMap: getStarsMap,
    getStars: getStars,
    saveStars: saveStars,
    getTotalStars: getTotalStars,
    getRatings: getRatings,
    saveRating: saveRating,
    readJson: readJson,
    // BATCH 55 — storage-integrity surface (read-only health + the explicit recovery action).
    getStorageHealth: getStorageHealth,
    readQuarantinedRaw: readQuarantinedRaw,
    recoverPoisonedKey: recoverPoisonedKey,
    writeJson: writeJson,
    requestPersistentStorage: requestPersistentStorage,
    clearAllStoredData: clearAllStoredData,
    createTimer: createTimer,
    formatSeconds: formatSeconds,
    randomBetween: randomBetween,
    randomChoice: randomChoice,
    clamp: clamp,
    getDifficultySettings: getDifficultySettings,
    createTarget: createTarget,
    createMovingTarget: createMovingTarget,
    createRedGreenCalibration: createRedGreenCalibration,
    mapAmblyopicEyeToColour: mapAmblyopicEyeToColour,
    getRedGreenChannels: getRedGreenChannels,
    syncRedGreenChannels: syncRedGreenChannels,
    channelHex: channelHex,
    getChannelAlpha: getChannelAlpha,
    getStimulusColour: getStimulusColour,
    renderStimulusElement: renderStimulusElement,
    applyStimulusElement: applyStimulusElement,
    getStimulusChannels: getStimulusChannels,
    createStimulusConfig: createStimulusConfig,
    calculateSuppressionFlag: calculateSuppressionFlag,
    fitCanvasToDisplay: fitCanvasToDisplay,
    resizeGameCanvas: resizeGameCanvas,
    getPointerPosition: getPointerPosition,
    clearCanvas: clearCanvas,
    roundedRect: roundedRect,
    drawFixation: drawFixation,
    createScore: createScore,
    activateGameKeyboardControls: activateGameKeyboardControls,
    deactivateGameKeyboardControls: deactivateGameKeyboardControls
  };
})();
